export const environment = {
    production: true,
    hmr       : false,
    api_url   : "$ENV.api_url",
    cliente: "$ENV.cliente"

};
